import { matchPath } from 'react-router'
import { createSelector } from 'reselect'

export const getSelectedItineraryDate = createSelector(
  (state: App.State) => state.router.location.pathname,
  (state: App.State) => state.tripPlanner.selectedDate,
  (pathname, selectedDateByTripId) => {
    const match = matchPath<{ tripId: string }>(pathname, [
      '/:regionCode/trip-planner/trip/:tripId/itinerary',
      '/:regionCode/trip-planner/webView/:tripId/map',
      '/:regionCode/trip-planner/public-trip/:tripId/itinerary',
    ])
    return match ? selectedDateByTripId[match.params.tripId] : undefined
  },
)

export const getTripFilters = (state: App.State) => {
  return state.tripPlanner.selectedSubFilters
}
